import { observer } from "mobx-react";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import { Tooltip } from "../../../../../../../components/tooltip/tooltip";
import { RMA_STATUS } from "../../../../rma-types";
import RmaPageStore from "../../../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    rmaPageStore: RmaPageStore;
};

const MissingShipmentValue: React.FC<IProps> = observer(({ rmaPageStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    return (
        <Tooltip content={(
            rmaPageStore.status === RMA_STATUS.PENDING_APPROVAL &&
                <FontBody3 color={FONT_COLOR.NEUTRAL_WHITE}>{getTranslation('DATA_VALUE_NO_VALUE_YET', pageScope)}</FontBody3>
        )}>
            <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{"--"}</FontBody3>
        </Tooltip>
    );
});

export default MissingShipmentValue;